import {EmbedContexts} from '#/contexts/app-contexts';
import {TailwindTheme, useTailwindTheme} from '#/hooks/use-tailwind-theme';
import {FunctionComponent} from 'react';
import {Outlet} from 'react-router';
import {useQueryParam} from 'use-query-params';

export const EmbedRoutesElement: FunctionComponent = () => {
  const [theme = 'dark'] = useQueryParam<TailwindTheme>('theme');

  useTailwindTheme(theme);

  return (
    <EmbedContexts>
      <Outlet />
    </EmbedContexts>
  );
};
